<template>
  <section class="where-use border">
    <div class="container container__title">
      <div class="info-area">Aplicaciones</div>
    </div>
    <div class="container hide-mobile">
      <div class="card" v-for="(card, index) in cards" :key="index">
        <img :src="card.image" :alt="card.title" />
        <div class="card-title" v-html="card.title" />
        <!-- <div class="card-text" v-html="card.text" /> -->
      </div>
    </div>
    <div class="hide-desktop scrolling-wrapper">
      <div class="card" v-for="(card, index) in cards" :key="index">
        <img :src="card.image" :alt="card.title" />
        <div class="card-title" v-html="card.title" />
        <!-- <div class="card-text" v-html="card.text" /> -->
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ["cards"],
};
</script>

<style lang="scss" src="./WhereUse.scss" />